// api/user.js
import request from "@/utils/request.js"

// 获取全部主体内容
export function getAllContent(term) {
    return request({
        url: `/getIntroduction&limit=${term.limit}`,
        method: "get",
    })
}
// 请求主体内容
export function requestThemeContent(term) {
    return request({
        url: `/getIntroduction?file=${term.address}&limit=${term.limit}`,
        method: "get",
    })
}
// 获取介绍页产品推荐
export function getRecommend(term) {
    return request({
        url: `/getIntroductionAdvantage?main=${term.address}&limit=${term.limit}`,
        method: "get",
    })
}
// 获取产品功能
export function getFunction(term) {
    return request({
        url: `/getIntroductionFunctionBlock?main=${term.address}&limit=${term.limit}`,
        method: "get",
    })
}
// 获取应用场景
export function getApplicationScenarios(term) {
    return request({
        url: `/getIntroductionScene?main=${term.address}&limit=${term.limit}`,
        method: "get",
    })
}
// 获取客户之声
export function getCustomerVoice(term) {
    return request({
        url: `/getIntroductionComment?main=${term.address}&limit=${term.limit}`,
        method: "get",
    })
}
// 获取对比项
export function getComparison(term) {
    return request({
        url: `/getIntroductionCompare?main=${term.address}&limit=${term.limit}`,
        method: "get",
    })
}
// 获取快速入门
export function getQuickStart(term) {
    return request({
        url: `/getIntroductionProcess?main=${term.address}&limit=${term.limit}`,
        method: "get",
    })
}